var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOurFeature5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2061 20.4358C18.7744 20.4358 19.3194 20.2101 19.7213 19.8082C20.1231 19.4063 20.3489 18.8613 20.3489 18.293",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63477 20.4365H12.8491",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3496 9.72168V12.936",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7776 9.72168C11.2093 9.72168 10.6643 9.94744 10.2624 10.3493C9.86053 10.7512 9.63477 11.2962 9.63477 11.8645",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06348 3.29325C1.06348 2.72493 1.28924 2.17988 1.6911 1.77802C2.09297 1.37616 2.63801 1.15039 3.20633 1.15039H18.2063C18.7747 1.15039 19.3197 1.37616 19.7216 1.77802C20.1234 2.17988 20.3492 2.72493 20.3492 3.29325V9.72182H26.7778C27.3461 9.72182 27.8911 9.94758 28.293 10.3494C28.6949 10.7513 28.9206 11.2964 28.9206 11.8647V26.8647C28.9206 27.433 28.6949 27.978 28.293 28.3799C27.8911 28.7818 27.3461 29.0075 26.7778 29.0075H11.7778C11.2094 29.0075 10.6644 28.7818 10.2625 28.3799C9.86067 27.978 9.6349 27.433 9.6349 26.8647V20.4361H3.20633C2.63801 20.4361 2.09297 20.2103 1.6911 19.8085C1.28924 19.4066 1.06348 18.8616 1.06348 18.2932V3.29325Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1348 9.72168H20.3491",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63477 17.2217V20.436",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(-0.0078125 0.0791016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurFeature5);
export default __webpack_public_path__ + "static/media/icon-our-feature-5.c6a33cc4e3bffd76cf1466f1cbcdd718.svg";
export { ForwardRef as ReactComponent };